export enum EventType {
  Click = "click",
  View = "view",
  AddToCart = "add_to_cart",
  Purchase = "purchase",
  Request = "request",
  Reserve = "reserve",
}
